import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Util} from "../../app/util";
import {CONFIG} from "../../app/config";
import {LogadoService} from "../../providers/logado-service";
import {ENUM} from "../../app/enum";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-teclado',
    templateUrl: 'app-teclado.html'
})

export class AppTeclado {

    ENUM: any = ENUM;
    config: any;

    arrayOne: any = [];
    arrayTwo: any = [];

    styleOne: string;
    widthDiv: number;

    @Input('size') public size: 0 | 60 | 80 | 100 | 120 = 0;
    @Input('viewer') public viewer: 'mini' | 'full' = 'full';
    @Input('ponto')  public ponto: boolean = false;

    @Output('teclado-okey') private _okey: EventEmitter<any> = new EventEmitter();

    constructor(public util: Util, public logadoService: LogadoService, public sanitizer: DomSanitizer) {

        this.config = CONFIG;

    }

    ngOnInit() {
        
        if (this.size == 0)  this.size = (window.innerHeight < 700 ? 60 : 80);

        if (this.size == 60)  this.styleOne = 'size-60';
        if (this.size == 80)  this.styleOne = 'size-80';
        if (this.size == 100) this.styleOne = 'size-100';
        if (this.size == 120) this.styleOne = 'size-120';

        this.styleOne = this.styleOne + ' ' + ((this.size <= 60) ? 'margin-3' : 'margin-5');
        this.widthDiv = ((this.size <= 60 ? 80 : this.size) * 3) + (10 * 3);

        if (this.viewer == 'full') this.arrayOne = [1,2,3,4,5,6,7,8,9, 'erase', 0, 'left-thin'];
        if (this.viewer == 'mini') this.arrayOne = [1,2,3,4,5,6,7,8,9, 'erase', 0, (this.ponto ? 'dot' : 'ok')];

        if (this.viewer == 'full') this.arrayTwo = (this.ponto ? ['ok', 'cancel', null, 'dot'] : ['ok', 'cancel']);
        if (this.viewer == 'mini') this.arrayTwo = [];

    }

    _emitBtn(btn) {

        this.util.impact();
        this._okey.emit(btn);

    }

}



// WEBPACK FOOTER //
// ./src/components/app-teclado/app-teclado.ts